// Lightweight base58 Solana address check (length + alphabet).
export const isValidSolanaAddress = (addr) => {
  if (!addr) return false;
  const a = addr.trim();
  if (a.length < 32 || a.length > 44) return false;
  return /^[1-9A-HJ-NP-Za-km-z]+$/.test(a);
};

export const shortAddr = (a) => (a ? `${a.slice(0, 4)}…${a.slice(-4)}` : "");

export const timeAgo = (tsSeconds) => {
  if (!tsSeconds) return "—";
  const diff = Math.max(0, Date.now() / 1000 - tsSeconds);
  if (diff < 60) return `${Math.round(diff)}s ago`;
  if (diff < 3600) return `${Math.round(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.round(diff / 3600)}h ago`;
  return `${Math.round(diff / 86400)}d ago`;
};
